<div class="ibox-content">
    <form [formGroup]="form">
      <div class="form-group row">
        <mat-error *ngIf="MensajeError" class="eliminacionInvalida">{{MensajeError}}</mat-error>
        <mat-error *ngIf="MensajeRetro && !MensajeError && formHabilitado" class="eliminacionInvalida">{{MensajeRetro}}</mat-error>
      </div>
      <div class="row" hidden="true">
        <input formControlName="id" name="id" type="text" class="form-control" />
        <input formControlName="personal" name="personal" type="text" class="form-control" />
      </div>
      <div class="row panel panel-warning" *ngIf="!disabledEditing">
        <div class="col-lg">
          <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
          <div class="col-lg-8">
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="desde" dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
            <div *ngIf="registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched)" class="text-danger">La Fecha es Requerida</div>
            <mat-error *ngIf="desdeAnterior && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
            </mat-error>
            <mat-error *ngIf="anteriorRetroactividad && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al límite de retroactividad {{grupoLiq.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
            </mat-error>
          </div>
        </div>
        <div class="col-lg">
          <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
          <div class="col-lg-8">
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="hasta" dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
            <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)" class="text-danger">La Fecha es Requerida</div>
            <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)">
                La Fecha no puede ser menor que la Fecha Desde
            </mat-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
            <label class="col-form-label font-bold">Clase de Ausentismo</label>
            <div>
              <comboTools [list]=claseAusentismoList
                          selected='claseAusentismo'
                          [formParent]="form"
                          [isEditing]=disabledEditing
                          filter="descripcion"
                          (SelectedChange)="onChangeClaseAusentismo($event)"
                          ph='Clase de Ausentismo'>
              </comboTools>
              <div *ngIf="registerFormControl.claseAusentismo.invalid && (
                registerFormControl.claseAusentismo?.dirty || registerFormControl.claseAusentismo?.touched || submitted)" class="text-danger">
                La Clase de Ausentismo es Requerida
              </div>
            </div>
        </div>
      </div>
      <div class="row" *ngIf="porHoras">
        <div class="col-md-6">
          <label class="col-form-label font-bold" for="horaDesde">Hora Desde</label>
          <input type="time" formControlName="horaDesde" name ="selectedhoraDesde" class="form-control" (ngModelChange)="onChangeHoras()" [ngClass]="{ 'is-invalid': registerFormControl.horaDesde.errors && (registerFormControl.horaDesde?.dirty || registerFormControl.horaDesde?.touched || submitted)}"/>
          <div *ngIf="registerFormControl.horaDesde.errors?.required && (registerFormControl.horaDesde?.dirty || registerFormControl.horaDesde?.touched || submitted)" class="text-danger">
            La Hora Desde es requerida
          </div>
        </div>
        <div class="col-md-6">
          <label class="col-form-label font-bold" for="horaHasta">Hora Hasta</label>
          <input type="time" formControlName="horaHasta" name ="selectedhoraHasta" class="form-control" (ngModelChange)="onChangeHoras()" [ngClass]="{ 'is-invalid': registerFormControl.horaHasta.errors && (registerFormControl.horaHasta?.dirty || registerFormControl.horaHasta?.touched || submitted)}"/>
          <div *ngIf="registerFormControl.horaHasta.errors?.required && (registerFormControl.horaHasta?.dirty || registerFormControl.horaHasta?.touched || submitted)" class="text-danger">
            La Hora Hasta es requerida
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label font-bold">Código Nómina</label>
          <div>
            <comboTools [list]=NominaList
                        selected='codigoNomina'
                        [formParent]="form"
                        [isEditing]=true
                        filter="descripcion"
                        ph='Código Nómina'>
            </comboTools>
          </div>
        </div> 
        <div class="col-md-6">
          <label class="col-form-label font-bold">Unidad Tiempo</label>
          <div>
            <comboTools [list]=unidadesTiempoList
                        selected='unidadTiempo'
                        [formParent]="form"
                        [isEditing]=true
                        filter="descripcion"
                        ph='Unidad Tiempo'>
            </comboTools>
            <div *ngIf="registerFormControl.unidadTiempo.invalid && (
              registerFormControl.unidadTiempo?.dirty || registerFormControl.unidadTiempo?.touched || submitted)" class="text-danger">
              La Unidad Tiempo es requerida
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
            <label class=" col-form-label font-bold">{{labelCantidad}}</label>
            <input formControlName="cantidad" name ="selectedCantidad" type="number" class="form-control" (ngModelChange)="onChangeCantidad()" [ngClass]="{ 'is-invalid': registerFormControl.cantidad.errors && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)}"/>
            <mat-error  class="text-danger"*ngIf="registerFormControl.cantidad.errors?.required && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)">
                La Cantidad es Requerida
            </mat-error>            
            <mat-error *ngIf="registerFormControl.cantidad.errors?.cantidadCero && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)" class="text-danger">
                La cantidad debe ser mayor a cero
            </mat-error>
            <mat-error *ngIf="registerFormControl.cantidad.errors?.sinCalendario && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)" class="text-danger">
                Debe definir el Calendario de Trabajo para calcular los días
            </mat-error>
        </div>
        <div class="col-md-6">
            <label class=" col-form-label font-bold">Consumo Contingente</label>
            <input formControlName="consumoContingente" name ="selectedConsumo" type="number" class="form-control" disabled/>
        </div>
      </div>  
    </form>
  </div>
  
  